import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M33.3 26.25q-.45-.45-.45-1.05 0-.6.45-1.05l5-5H24q-.65 0-1.075-.425-.425-.425-.425-1.075 0-.65.425-1.075.425-.425 1.075-.425h14.3l-5.05-5.05q-.45-.45-.425-1.025.025-.575.475-1.025.45-.45 1.05-.45.6 0 1.05.45l7.55 7.55q.25.25.35.5.1.25.1.55 0 .3-.1.55-.1.25-.35.5l-7.6 7.6q-.45.45-1.025.425-.575-.025-1.025-.475Zm-20.7 12.7L5.05 31.4q-.25-.25-.35-.5-.1-.25-.1-.55 0-.3.1-.55.1-.25.35-.5l7.6-7.6q.45-.45 1.025-.425.575.025 1.025.475.45.45.45 1.05 0 .6-.45 1.05l-5 5H24q.65 0 1.075.425.425.425.425 1.075 0 .65-.425 1.075-.425.425-1.075.425H9.7l5.05 5.05q.45.45.425 1.025-.025.575-.475 1.025-.45.45-1.05.45-.6 0-1.05-.45Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }